module.exports = __webpack_public_path__ + "img/text2.da637360.svg";